const Gender = [
    { id: 1,
     name: 'LAKI - LAKI'
    },
    { id: 2,
     name: 'PEREMPUAN'
    }
]

const getGenderByName = (name) => {
    if(!name){
        return 1
    }
    const gender = Gender.filter(data => data.name === name.toUpperCase())

    if(gender.length === 0){
        return 1
    }

    return gender[0].id
}

const getGenderName = (id) => {
    if(!id){
        return 'NONE'
    }
    const gender = Gender.filter(data => data.id === id)
    return gender[0].name
}



export {
    Gender,
    getGenderName,
    getGenderByName
}
